export const ACTIONS = {
  FETCH: 'fetch',
  CREATE: 'add',
  DELETE: 'delete',
  EDIT: 'edit',
}